export default __webpack_public_path__ + "static/media/invitation-sent.dc499dbe.png";